"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDF_EDIT_MAX_BYTES = void 0;
/**
 * Largest PDF that is edited as a whole in memory (inserting visual
 * signatures with pdf-lib, server-side signing). Viewing has no such limit:
 * it reads byte ranges.
 */
exports.PDF_EDIT_MAX_BYTES = 256 * 1024 * 1024;
